<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="6" width="18" height="13" rx="2" stroke="currentColor" stroke-width="1.6"/>
<path d="M3 10h18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
<circle cx="16.5" cy="14.5" r="1.3" stroke="currentColor" stroke-width="1.6"/>
</svg>
</template>
